import { Typography, Button, Tooltip } from "@kaltura/ds-react-components";
import { RemoveItem24Icon } from "@kaltura/ds-react-icons";
import { formatters, translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { MediaType } from "../../types";
import {
    ThumbnailContainer,
    Thumbnail,
    Duration,
    ContentSection,
    TitleContainer,
    MediaInfo,
    Separator,
    StyledContainer,
} from "./styledComponents";
import { Badge, TruncatedLine } from "@kaltura/mediaspace-shared-ui";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

interface MediaItemCardProps {
    item: MediaType;
    onRemove?: () => void;
}

/**
 * MediaItemCard component - Displays the content of a media item card in the sort list
 */
export const MediaItemCard = (props: MediaItemCardProps) => {
    const { item, onRemove } = props;

    const theme = useTheme();
    const isXsScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.sm));

    const entry = item.entry;
    const scheduledForPublishOnDifferentTime = entry.startDate || entry.endDate;

    const sendButtonAnalytics = useButtonAnalytics();

    const handleRemove = () => {
        sendButtonAnalytics("Remove Media Item", ButtonClickAnalyticsType.DELETE, item.entry.id);
        onRemove?.();
    };

    return (
        <StyledContainer>
            {!isXsScreen && (
                <ThumbnailContainer>
                    <Thumbnail
                        style={{
                            backgroundImage: item.entry?.thumbnailUrl ? `url(${item.entry.thumbnailUrl})` : "none",
                        }}
                    />
                    {item.showDurationOnThumbnail
                        && item.entry.duration !== undefined
                        && item.entry.duration !== null
                        && item.entry.duration > 0 && (
                            <Duration>{formatters.formatSecondsToTime(item.entry.duration)}</Duration>
                        )}
                </ThumbnailContainer>
            )}

            <ContentSection>
                <TitleContainer>
                    <TruncatedLine>
                        <Typography variant="body2Highlight">{item.entry?.name}</Typography>
                    </TruncatedLine>
                    {scheduledForPublishOnDifferentTime && (
                        <Badge label={translate("Scheduled")} size={"small"} mode={"light"} />
                    )}
                </TitleContainer>

                <MediaInfo>
                    <Typography variant="body2Highlight">{item.entryTypeName}</Typography>
                    <Separator>•</Separator>
                    <TruncatedLine>
                        <Typography variant="body2Highlight">
                            {translate("Created by %1", [item.userDisplayName])}
                        </Typography>
                    </TruncatedLine>
                </MediaInfo>
            </ContentSection>

            <Tooltip title={translate("Remove")}>
                <Button variant="borderless" color="secondary" onClick={handleRemove} aria-label={translate("Remove")}>
                    <RemoveItem24Icon />
                </Button>
            </Tooltip>
        </StyledContainer>
    );
};
